import { Colors } from '../../theme'

export default {
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ['@media all and (max-width:1200px)']: { // eslint-disable-line no-useless-computed-key
      display: 'none !important'
    }
  },
  responsivePagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
    '& p': {
      margin: '0 10px'
    },
    ['@media all and (max-width:320px)']: { // eslint-disable-line no-useless-computed-key
      flexDirection: 'column'
    }
  },
  paginationButtons: {
    '& ul': {
      display: 'flex',
      padding: 0,
      '& li': {
        transition: '0.2s'
      }
    },
    '& li.active:hover': {
      backgroundColor: Colors.Palette.primaryColorMuted
    }
  },
  pageButton: {
    lineHeight: '35px !important',
    minHeight: 35,
    width: 35,
    borderRadius: 50,
    margin: '0px 5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: '#EAEAEA',
      cursor: 'pointer'
    },
    '&.active': {
      background: Colors.Palette.primaryColor,
      color: 'white'
    }
  },
  itemPerPage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minWidth: 320,
    float: 'right',
    '& ul': {
      display: 'flex',
      margin: 0
    },
    '& li': {
      transition: '0.2s'
    },
    '& li:hover': {
      background: '#EAEAEA',
      cursor: 'pointer'
    },
    '& li.active:hover': {
      background: Colors.Palette.primaryColorMuted
    },
    ['@media all and (max-width:768px)']: { // eslint-disable-line no-useless-computed-key
      width: '100%',
      display: 'none !important'
    }
  },
  claimTitleBox: {
    marginTop: 15,
    border: '1px solid rgba(0,0,0,0)',
    display: 'block'
  }
}



// WEBPACK FOOTER //
// ./src/styles/components/pagination.js